import React, { Component, ReactNode } from "react";

interface ErrorBoundaryProps {
    fallback: ReactNode; // What to render in case of an error
    children: ReactNode; // The component's children
}

interface ErrorBoundaryState {
    hasError: boolean; // Tracks if an error has been caught
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    state: ErrorBoundaryState = { hasError: false };

    // Update state when an error is thrown
    static getDerivedStateFromError(_: Error): ErrorBoundaryState {
        return { hasError: true };
    }

    // Log error details
    componentDidCatch(error: Error, info: React.ErrorInfo): void {
        console.debug("ErrorBoundary caught an error:", error, info);
    }

    render() {
        if (this.state.hasError) {
            return this.props.fallback; // Render fallback UI
        }
        return this.props.children; // Render children if no error
    }
}

export default ErrorBoundary;
